export default  {
    notValid: 0,
    valid: 1,
    intermediate: 2
}